import React, { useEffect, useState } from 'react';
import Alert from '../../../layouts/Alert';
import _ from 'underscore';

import UserListItem from './UserListItem';
import Search from '../../../layouts/Search';
import SortIcon from '../../../layouts/SortIcon';
import UserFilter from './UserFilter';
import Pagination from '../../../layouts/Pagination';

const UsersList = ({ authUser, usersList, userListLoading }) => {
  const [listSearch, setListSearch] = useState(usersList);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const [icons, setIcons] = useState({
    name: 0,
    email: 0,
    role: 0,
    client: 0,
  });

  const { email, role, client } = icons;

  useEffect(() => {
    if (!userListLoading) {
      setListSearch(usersList);
    }
  }, [userListLoading, setListSearch, usersList]);

  const setFilter = (data) => {
    setListSearch(
      usersList.filter(
        (item) =>
          (data.roleID === '' ? true : item.role_id + '' === data.roleID) &&
          (data.clientID === '' ? true : item.client_id + '' === data.clientID),
      ),
    );
  };

  return (
    <div className='card w-100 p-2 p-sm-3 p-lg-5 shadow-lg border-0 admin-list h-100'>
      <Alert />
      <div className='d-flex w-100 align-items-center justify-content-between mb-3'>
        <div className=''>
          {!userListLoading && listSearch.length / 7 > 1 && (
            <Pagination
              listSearch={listSearch}
              setPage={setPage}
              size={7}
              page={page}
            />
          )}
        </div>
        <div className='d-flex'>
          <Search
            setListSearch={setListSearch}
            filter={(e) => {
              const list = usersList.filter(
                (item) =>
                  item.email
                    .toUpperCase()
                    .includes(e.target.value.toUpperCase()) ||
                  item.role
                    .toUpperCase()
                    .includes(e.target.value.toUpperCase()) ||
                  (item.client
                    ? item.client
                        .toUpperCase()
                        .includes(e.target.value.toUpperCase())
                    : false),
              );
              return list;
            }}
            setSearch={setSearch}
          />
          <UserFilter
            usersList={usersList}
            setFilter={setFilter}
            setListSearch={setListSearch}
            isAdmin={authUser.role_id == 1}
          />
        </div>
      </div>
      <div className='row m-0 rounded admin-list-header txt-primary p-2 w-100'>
        <div className='admin-list-fields col p-0 text-truncate '>UserID</div>
        <div
          className='admin-list-fields col p-0 text-truncate '
          onClick={() => {
            if (email === 0) {
              setListSearch(_.sortBy(listSearch, 'email'));
              setIcons({
                email: 1,
                role: 0,
                client: 0,
              });
            } else if (email === 1) {
              let l = _.sortBy(listSearch, 'email');
              setListSearch(l.reverse());
              setIcons({
                email: -1,
                role: 0,
                client: 0,
              });
            } else {
              setListSearch(usersList);
              setIcons({
                email: 0,
                role: 0,
                client: 0,
              });
            }
          }}
        >
          Email
          <SortIcon icon={email} />
        </div>
        <div
          className='admin-list-fields col p-0  text-truncate '
          onClick={() => {
            if (role === 0) {
              setListSearch(_.sortBy(listSearch, 'role'));
              setIcons({
                role: 1,
                email: 0,
                client: 0,
              });
            } else if (role === 1) {
              let l = _.sortBy(listSearch, 'role');
              setListSearch(l.reverse());
              setIcons({
                role: -1,
                email: 0,
                client: 0,
              });
            } else {
              setListSearch(usersList);
              setIcons({
                email: 0,
                role: 0,
                client: 0,
              });
            }
          }}
        >
          Role
          <SortIcon icon={role} />
        </div>
        <div
          className='admin-list-fields col p-0  text-truncate '
          onClick={() => {
            if (client === 0) {
              setListSearch(_.sortBy(listSearch, 'client'));
              setIcons({
                client: 1,
                role: 0,
                email: 0,
              });
            } else if (client === 1) {
              let l = _.sortBy(listSearch, 'client');
              setListSearch(l.reverse());
              setIcons({
                client: -1,
                role: 0,
                email: 0,
              });
            } else {
              setListSearch(usersList);
              setIcons({
                client: 0,
                email: 0,
                role: 0,
              });
            }
          }}
        >
          Company
          <SortIcon icon={client} />
        </div>
        <div className='admin-list-fields col p-0 text-truncate text-center'>
          Actions
        </div>
      </div>
      <div className='admin-list-body '>
        {userListLoading ? (
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          listSearch
            .slice(7 * (page - 1), 7 * page)
            .map((user, id) => <UserListItem user={user} key={id} />)
        )}
      </div>
    </div>
  );
};

export default UsersList;
